export default {"src":"/_next/static/media/ll-image-loader-anim.b40a63c3.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};